export default {
    ca: {
        title: 'Estem preparant un nou taller d\'InstaMaps. T\'interessa?',
        message: 'Si vols més informació, deixa\'ns aquí el teu email',
    },
    es: {
        title: 'Estamos preparando un nuevo taller de InstaMaps. ¿Te interesa?',
        message: 'Si quieres más información, déjanos aquí tu email',
    },
    en: {
        title: 'We are preparing a new InstaMaps workshop. Are you interested?',
        message: 'If you want more information, please give us your email',
    },
};



// WEBPACK FOOTER //
// ./src/shared/components/message-modal/message-modal-translations.js